import React from 'react';

import { Button, Grid, Typography } from '@mui/material';

import { DateFormatPatterns } from '@clearverify/constants';
import { formatDate } from '@clearverify/utils';

import { ModalId } from 'src/constants/modals';
import { useScreenInfo } from 'src/hooks/common';
import { useModal } from 'src/hooks/shared';
import { useCurrentUser, useCurrentUserPermissions } from 'src/hooks/user';
import { UserCreatePasswordChangeRequestModal } from 'src/modals/userPasswordChangeRequest';

export const PasswordChangeRequest: React.FC = () => {
  const { openModal } = useModal();
  const { isMobile } = useScreenInfo();

  const handleChangePasswordClick = React.useCallback(() => {
    openModal(ModalId.UserCreatePasswordChangeRequestModal);
  }, [openModal]);

  const { user } = useCurrentUser();
  const { hasVerifierRoles } = useCurrentUserPermissions();

  const lastPasswordChange = React.useMemo(() => {
    const dateToFormat = user?.lastPasswordChangeAt ? user.lastPasswordChangeAt : user?.createdAt;
    return formatDate(dateToFormat, DateFormatPatterns.shortDateWithSlash);
  }, [user?.createdAt, user?.lastPasswordChangeAt]);

  return (
    <Grid container spacing={isMobile ? 1 : 4} px={hasVerifierRoles && isMobile ? 3 : 0}>
      <Grid size={12}>
        <Grid
          container
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={3}
          border={1}
          borderRadius={2}
          borderColor="border.light"
        >
          <Grid>
            <Typography component="h3" variant="subtitle1" fontSize="16px">
              Password
            </Typography>
            <Typography component="p" variant="h3" fontSize="16px" lineHeight="24px" color="grey">
              Your active password was created on {lastPasswordChange}
            </Typography>
          </Grid>
          <Grid>
            <Button
              variant={isMobile ? 'outlined' : 'contained'}
              type="submit"
              onClick={handleChangePasswordClick}
            >
              Change Password
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <UserCreatePasswordChangeRequestModal />
    </Grid>
  );
};
